import { useCustomerStore } from '@shared/global-store/stores/customer/customer'
import { useLocationStore } from '@shared/global-store/stores/location/location'
import type { TypedDocumentString } from '@shared/types/customer/graphql'

import { isHttpError } from '@fond-of/api-client'

export const execute = async <TResult, TVariables>(
  query: TypedDocumentString<TResult, TVariables>,
  ...[variables]: TVariables extends Record<string, never> ? [] : [TVariables]
): Promise<TResult | null> => {
  const locationStore = useLocationStore()
  const { token } = useCustomerStore()

  const url = import.meta.env.PUBLIC_SHOPIFY_CUSTOMER_ACCOUNT_API_URL

  if (!url) {
    throw new Error('Customer Account API environment variable is not set')
  }

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token ?? '',
      },
      body: JSON.stringify({
        query,
        variables: {
          ...variables,
          country: locationStore.country,
          language: locationStore.language,
        },
      }),
    })
    const resp = await response.json()

    if (resp.errors) {
      console.log('GraphQL errors', resp.errors)
    }

    return resp.data as TResult
  } catch (error) {
    console.error(
      'Failed to fetch Shopify data',
      isHttpError(error) ? await error.response.json() : error
    )
    return null
  }
}
